import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
const initialState = {
  teamPerfomanceOverview: {
    responseData: {},
    loading: false,
  },
  dailyTeamRevenue: {
    responseData: {},
    loading: false,
  },
  dailyAssessmentCount: {
    responseData: {},
    loading: false,
  },
  teamWiseAnalysis: {
    responseData: {},
    loading: false,
  },
  projectWise: {
    responseData: {},
    loading: false,
  },
  ogdOverview: {
    responseData: {},
    loading: false,
  },
  teamUserPerfomance: {
    responseData: {},
    loading: false,
  },
  chaserCrewPerfomance: {
    responseData: {},
    loading: false,
  },
  detailedPerfomanceMetrics: {
    responseData: {},
    loading: false,
  },
  // The rebuild. Its own slot, its own endpoint, sharing nothing with the entry
  // above so the live table is never affected while this one is being written.
  ogdPointTracker: {
    responseData: {},
    loading: false,
  },
  overView: {
    responseData: {},
    loading: false,
  },
  specialPerformers: {
    responseData: {},
    loading: false,
  },
  bestTeamList: {
    responseData: {},
    loading: false,
    lastTime: null,
  },
  milestoneAchievers: {
    responseData: {},
    loading: false,
  },
  dailyRevenueData: {
    responseData: {},
    loading: false,
  },
  assessmentTotal: {
    responseData: {},
    loading: false,
  },
  projectWisePerformance: {
    responseData: {},
    loading: false,
  },
  feeCollection: {
    responseData: {},
    loading: false,
  },
  performanceBreakdown: {
    responseData: {},
    loading: false,
  },
  sogoDashboardCards: {
    responseData: {},
    loading: false,
  },
  sogoCards: {
    responseData: {},
    loading: false,
  },
  ogaMileStone: {
    responseData: {},
    loading: false,
  },
  individualCards: {
    data: [],
    loading: false,
  },
  individualMonthlyPerfomance: {
    data: [],
    loading: false,
  },
  courseSaleMatrix: {
    data: [],
    loading: false,
  },
  projectTrend: {
    data: [],
    loading: false,
  },

  courseTrend: {
    data: [],
    loading: false,
  },

  projectMonthlyStats: {
    data: [],
    loading: false,
  },

  wingProjectPivot: {
    data: [],
    loading: false,
  },
  projectPerformanceSummary: {
    data: [],
    loading: false,
  },
};

// ...................Thunks..........................

export const perfomanceOverview = createAsyncThunk('pointTrackerSlice/perfomanceOverview', async (dispatchParams) => {
  const url = `/point-tracker/performance-overview?date=${dispatchParams.date}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

export const getDailyTeamRevenue = createAsyncThunk('pointTrackerSlice/getDailyTeamRevenue', async (dispatchParams) => {
  const url = `/point-tracker/daily-revenue?date=${dispatchParams.date}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

export const getDailyAssessments = createAsyncThunk('pointTrackerSlice/getDailyAssessments', async (dispatchParams) => {
  const url = `/point-tracker/daily-assessments?date=${dispatchParams.date}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

export const getTeamWiseAnalysis = createAsyncThunk('pointTrackerSlice/getTeamWiseAnalysis', async (dispatchParams) => {
  const url = `/point-tracker/weekly-performance?date=${dispatchParams.date}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

export const getProjectWise = createAsyncThunk('pointTrackerSlice/getProjectWise', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });

  const url = `/point-tracker/project-performance?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

export const getOgdOverview = createAsyncThunk('pointTrackerSlice/getOgdOverview', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });
  const url = `/point-tracker/performance-cards?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

export const getTeamUserPerfomance = createAsyncThunk(
  'pointTrackerSlice/getTeamUserPerfomance',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/team-user-performance?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);

export const getChaserCrewPerfomance = createAsyncThunk(
  'pointTrackerSlice/getChaserCrewPerfomance',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
      projectId: dispatchParams.projectId,
      courseId: dispatchParams.courseId,
    });
    const url = `/point-tracker/wing-performance?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);

export const getDetailedPerfomanceMetrics = createAsyncThunk(
  'pointTrackerSlice/getDetailedPerfomanceMetrics',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/sales-scorecard?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);
//==============OGD Point Tracker, the rebuild===============
export const getOgdPointTracker = createAsyncThunk(
  'pointTrackerSlice/getOgdPointTracker',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    // the ticked squads, already a comma separated string. Left off entirely when
    // empty, which the server reads as the five selling squads.
    if (dispatchParams.wingIds) urlParams.append('wingIds', dispatchParams.wingIds);
    const url = `/ogd-point-tracker/detailed-performance-metrics?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);
//==============overView Cards===============
export const getOverView = createAsyncThunk('pointTrackerSlice/getOverView', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });
  const url = `/point-tracker/performance-overview-cards?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});
//======================special performers====================

export const getSpecialPerformers = createAsyncThunk(
  'pointTrackerSlice/getSpecialPerformers',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/special-performers?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);

//===============best team list performers  ==================

export const getBestTeamperformance = createAsyncThunk(
  'pointTrackerSlice/getBestTeamperformance',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/team-performance?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);

//=============/milestone-achievers=========

export const getMilestoneAchievers = createAsyncThunk(
  'pointTrackerSlice/getMilestoneAchievers',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/milestone-achievers?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);
//=============dialy Revenue=========

export const getDialyRevenueData = createAsyncThunk('pointTrackerSlice/getDialyRevenueData', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });
  const url = `/point-tracker/daily-revenue-data?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

//=============assessment total=========

export const getAssessmentTotal = createAsyncThunk('pointTrackerSlice/getAssessmentTotal', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });
  const url = `/point-tracker/daily-assessment-stats?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

//===========project wise perormance

export const getProjectWisePerformance = createAsyncThunk(
  'pointTrackerSlice/getProjectWisePerformance',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/project-performance-stats?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);
//=======================================

export const getFeeCollection = createAsyncThunk('pointTrackerSlice/getFeeCollection', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    month: dispatchParams.month,
  });

  const url = `/point-tracker/fee-collection?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

//===========================================================================

//===============SOGO Milestone===================================

//====================performance breakdown=======================

export const getPerformanceBreakdown = createAsyncThunk(
  'pointTrackerSlice/getPerformanceBreakdown',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/staff-performance-breakdown?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);

//====================sogo dashboards card=======================

export const getSogodashboardCards = createAsyncThunk(
  'pointTrackerSlice/getSogodashboardCards',
  async (dispatchParams) => {
    const urlParams = new URLSearchParams({
      wingId: dispatchParams.wingId,
      fromDate: dispatchParams.fromDate,
      toDate: dispatchParams.toDate,
    });
    const url = `/point-tracker/performance-overview-cards-detailed?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
    });
    return res;
  },
);

//====================sogo header card=======================

export const getSogoCards = createAsyncThunk('pointTrackerSlice/getSogoCards', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId ?? '',
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });
  const url = `/point-tracker/sogo-milestones?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});

//====================OGA Milestone======================

export const getOGAMilestone = createAsyncThunk('pointTrackerSlice/getOGAMilestone', async (dispatchParams) => {
  const urlParams = new URLSearchParams({
    wingId: dispatchParams.wingId,
    fromDate: dispatchParams.fromDate,
    toDate: dispatchParams.toDate,
  });
  const url = `/point-tracker/oga-milestones?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url: url,
  });
  return res;
});
//==========================================================

//=================== Individual Section ====================

export const getIndividualCards = createAsyncThunk(
  'pointTrackerSlice/getIndividualCards',
  async (params, { signal }) => {
    const urlParams = new URLSearchParams(params);
    const url = `/point-tracker/squad-performance?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
      signal,
    });
    return res;
  },
);

export const getIndividualMonthlyPerfomance = createAsyncThunk(
  'pointTrackerSlice/getIndividualMonthlyPerfomance',
  async (params, { signal }) => {
    const urlParams = new URLSearchParams(params);
    const url = `/point-tracker/individual-monthly-performance?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
      signal,
    });
    return res;
  },
);
export const getCourseSalesMatrix = createAsyncThunk(
  'pointTrackerSlice/getCourseSalesMatrix',
  async (params, { signal }) => {
    const urlParams = new URLSearchParams(params);
    const url = `/point-tracker/course-sales-matrix?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url: url,
      signal,
    });
    return res;
  },
);

//=================== Project Section ====================
// Project Trend
export const getProjectTrend = createAsyncThunk('pointTrackerSlice/getProjectTrend', async (params, { signal }) => {
  const urlParams = new URLSearchParams(params);
  const url = `/point-tracker/project-trend?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url,
    signal,
  });
  return res;
});

// Course Trend
export const getCourseTrend = createAsyncThunk('pointTrackerSlice/getCourseTrend', async (params, { signal }) => {
  const urlParams = new URLSearchParams(params);
  const url = `/point-tracker/course-trend?${urlParams}`;
  const res = await apiRequest({
    method: 'get',
    url,
    signal,
  });
  return res;
});

// Project Monthly Stats
export const getProjectMonthlyStats = createAsyncThunk(
  'pointTrackerSlice/getProjectMonthlyStats',
  async (params, { signal }) => {
    const urlParams = new URLSearchParams(params);
    const url = `/point-tracker/project-monthly-stats?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url,
      signal,
    });
    return res;
  },
);

// Wing Project Pivot
export const getWingProjectPivot = createAsyncThunk(
  'pointTrackerSlice/getWingProjectPivot',
  async (params, { signal }) => {
    const urlParams = new URLSearchParams(params);
    const url = `/point-tracker/wing-project-pivot?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url,
      signal,
    });
    return res;
  },
);

//project Summary
export const getProjectPerformanceSummary = createAsyncThunk(
  'pointTrackerSlice/getProjectPerformanceSummary',
  async (params, { signal }) => {
    const urlParams = new URLSearchParams(params);
    const url = `/point-tracker/project-performance-summary?${urlParams}`;
    const res = await apiRequest({
      method: 'get',
      url,
      signal,
    });
    return res;
  },
);

// main reducer
const pointTrackerSlice = createSlice({
  name: 'pointTracker',
  initialState,
  reducers: {
    clearTeamPerfomanceOverview: (state) => {
      return {
        ...state,
        teamPerfomanceOverview: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearDailyTeamRevenue: (state) => {
      return {
        ...state,
        dailyTeamRevenue: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearDailyAssessmentCount: (state) => {
      return {
        ...state,
        dailyAssessmentCount: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearTeamWiseAnalysis: (state) => {
      return {
        ...state,
        teamWiseAnalysis: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearProjectWise: (state) => {
      return {
        ...state,
        projectWise: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearOgdOverview: (state) => {
      return {
        ...state,
        ogdOverview: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearOgdPointTracker: (state) => {
      return {
        ...state,
        ogdPointTracker: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearTeamUserPerfomance: (state) => {
      return {
        ...state,
        teamUserPerfomance: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearChaserCrewPerfomance: (state) => {
      return {
        ...state,
        chaserCrewPerfomance: {
          responseData: {},
          loading: false,
        },
      };
    },
    clearDetailedPerfomanceMetrics: (state) => {
      return {
        ...state,
        detailedPerfomanceMetrics: {
          responseData: {},
          loading: false,
        },
      };
    },
  },
  extraReducers: (builder) => {
    //...............................perfomanceOverview......................//
    builder.addCase(perfomanceOverview.pending, (state, action) => {
      return {
        ...state,
        teamPerfomanceOverview: {
          ...state.teamPerfomanceOverview,
          loading: true,
        },
      };
    });
    builder.addCase(perfomanceOverview.fulfilled, (state, action) => {
      return {
        ...state,
        teamPerfomanceOverview: {
          ...state.teamPerfomanceOverview,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................dailyTeamRevenue......................//
    builder.addCase(getDailyTeamRevenue.pending, (state, action) => {
      return {
        ...state,
        dailyTeamRevenue: {
          ...state.dailyTeamRevenue,
          loading: true,
        },
      };
    });
    builder.addCase(getDailyTeamRevenue.fulfilled, (state, action) => {
      return {
        ...state,
        dailyTeamRevenue: {
          ...state.dailyTeamRevenue,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................dailyAssessmentCount......................//
    builder.addCase(getDailyAssessments.pending, (state, action) => {
      return {
        ...state,
        dailyAssessmentCount: {
          ...state.dailyAssessmentCount,
          loading: true,
        },
      };
    });
    builder.addCase(getDailyAssessments.fulfilled, (state, action) => {
      return {
        ...state,
        dailyAssessmentCount: {
          ...state.dailyAssessmentCount,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................teamWiseAnalysis......................//
    builder.addCase(getTeamWiseAnalysis.pending, (state, action) => {
      return {
        ...state,
        teamWiseAnalysis: {
          ...state.teamWiseAnalysis,
          loading: true,
        },
      };
    });
    builder.addCase(getTeamWiseAnalysis.fulfilled, (state, action) => {
      return {
        ...state,
        teamWiseAnalysis: {
          ...state.teamWiseAnalysis,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................projectWise......................//
    builder.addCase(getProjectWise.pending, (state, action) => {
      return {
        ...state,
        projectWise: {
          ...state.projectWise,
          loading: true,
        },
      };
    });
    builder.addCase(getProjectWise.fulfilled, (state, action) => {
      return {
        ...state,
        projectWise: {
          ...state.projectWise,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................ogdOverview......................//
    builder.addCase(getOgdOverview.pending, (state, action) => {
      return {
        ...state,
        ogdOverview: {
          ...state.ogdOverview,
          loading: true,
        },
      };
    });
    builder.addCase(getOgdOverview.fulfilled, (state, action) => {
      return {
        ...state,
        ogdOverview: {
          ...state.ogdOverview,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................teamUserPerfomance......................//
    builder.addCase(getTeamUserPerfomance.pending, (state, action) => {
      return {
        ...state,
        teamUserPerfomance: {
          ...state.teamUserPerfomance,
          loading: true,
        },
      };
    });
    builder.addCase(getTeamUserPerfomance.fulfilled, (state, action) => {
      return {
        ...state,
        teamUserPerfomance: {
          ...state.teamUserPerfomance,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................chaserCrewPerfomance......................//
    builder.addCase(getChaserCrewPerfomance.pending, (state, action) => {
      return {
        ...state,
        chaserCrewPerfomance: {
          ...state.chaserCrewPerfomance,
          loading: true,
        },
      };
    });
    builder.addCase(getChaserCrewPerfomance.fulfilled, (state, action) => {
      return {
        ...state,
        chaserCrewPerfomance: {
          ...state.chaserCrewPerfomance,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................ogdPointTracker, the rebuild...................//
    builder.addCase(getOgdPointTracker.pending, (state) => {
      return {
        ...state,
        ogdPointTracker: {
          ...state.ogdPointTracker,
          loading: true,
        },
      };
    });
    builder.addCase(getOgdPointTracker.fulfilled, (state, action) => {
      return {
        ...state,
        ogdPointTracker: {
          ...state.ogdPointTracker,
          responseData: action.payload,
          loading: false,
        },
      };
    });
    builder.addCase(getOgdPointTracker.rejected, (state) => {
      return {
        ...state,
        ogdPointTracker: {
          ...state.ogdPointTracker,
          loading: false,
        },
      };
    });

    //...............................detailedPerfomanceMetrics......................//
    builder.addCase(getDetailedPerfomanceMetrics.pending, (state, action) => {
      return {
        ...state,
        detailedPerfomanceMetrics: {
          ...state.detailedPerfomanceMetrics,
          loading: true,
        },
      };
    });
    builder.addCase(getDetailedPerfomanceMetrics.fulfilled, (state, action) => {
      return {
        ...state,
        detailedPerfomanceMetrics: {
          ...state.detailedPerfomanceMetrics,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //........................overView cards................
    builder.addCase(getOverView.pending, (state, action) => {
      return {
        ...state,
        overView: {
          ...state.overView,
          loading: true,
        },
      };
    });

    builder.addCase(getOverView.fulfilled, (state, action) => {
      return {
        ...state,
        overView: {
          ...state.overView,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //....................special performers.............

    builder.addCase(getSpecialPerformers.pending, (state, action) => {
      return {
        ...state,
        specialPerformers: {
          ...state.specialPerformers,
          loading: true,
        },
      };
    });

    builder.addCase(getSpecialPerformers.fulfilled, (state, action) => {
      return {
        ...state,
        specialPerformers: {
          ...state.specialPerformers,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //....................best team list .................

    builder.addCase(getBestTeamperformance.pending, (state, action) => {
      return {
        ...state,
        bestTeamList: {
          ...state.bestTeamList,
          loading: true,
        },
      };
    });

    builder.addCase(getBestTeamperformance.fulfilled, (state, action) => {
      return {
        ...state,
        bestTeamList: {
          ...state.bestTeamList,
          responseData: action.payload,
          loading: false,
          lastTime: Date.now(),
        },
      };
    });
    //.................milestone-achievers.................

    builder.addCase(getMilestoneAchievers.pending, (state, action) => {
      return {
        ...state,
        milestoneAchievers: {
          ...state.milestoneAchievers,
          loading: true,
        },
      };
    });

    builder.addCase(getMilestoneAchievers.fulfilled, (state, action) => {
      return {
        ...state,
        milestoneAchievers: {
          ...state.milestoneAchievers,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //.....................daily-revenue......................

    builder.addCase(getDialyRevenueData.pending, (state, action) => {
      return {
        ...state,
        dailyRevenueData: {
          ...state.dailyRevenueData,
          loading: true,
        },
      };
    });

    builder.addCase(getDialyRevenueData.fulfilled, (state, action) => {
      return {
        ...state,
        dailyRevenueData: {
          ...state.dailyRevenueData,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //.......................assessment Total...............

    builder.addCase(getAssessmentTotal.pending, (state, action) => {
      return {
        ...state,
        assessmentTotal: {
          ...state.assessmentTotal,
          loading: true,
        },
      };
    });

    builder.addCase(getAssessmentTotal.fulfilled, (state, action) => {
      return {
        ...state,
        assessmentTotal: {
          ...state.assessmentTotal,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //.......................project wise performance...............

    builder.addCase(getProjectWisePerformance.pending, (state, action) => {
      return {
        ...state,
        projectWisePerformance: {
          ...state.projectWisePerformance,
          loading: true,
        },
      };
    });

    builder.addCase(getProjectWisePerformance.fulfilled, (state, action) => {
      return {
        ...state,
        projectWisePerformance: {
          ...state.projectWisePerformance,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //...............................feeCollection......................//
    builder.addCase(getFeeCollection.pending, (state, action) => {
      return {
        ...state,
        feeCollection: {
          ...state.feeCollection,
          loading: true,
        },
      };
    });
    builder.addCase(getFeeCollection.fulfilled, (state, action) => {
      return {
        ...state,
        feeCollection: {
          ...state.feeCollection,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //......................................SOGO Milestone performance breakdown........................

    builder.addCase(getPerformanceBreakdown.pending, (state, action) => {
      return {
        ...state,
        performanceBreakdown: {
          ...state.performanceBreakdown,
          loading: true,
        },
      };
    });
    builder.addCase(getPerformanceBreakdown.fulfilled, (state, action) => {
      return {
        ...state,
        performanceBreakdown: {
          ...state.performanceBreakdown,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //......................................SOGO dashboard cards ........................

    builder.addCase(getSogodashboardCards.pending, (state, action) => {
      return {
        ...state,
        sogoDashboardCards: {
          ...state.sogoDashboardCards,
          loading: true,
        },
      };
    });
    builder.addCase(getSogodashboardCards.fulfilled, (state, action) => {
      return {
        ...state,
        sogoDashboardCards: {
          ...state.sogoDashboardCards,
          responseData: action.payload,
          loading: false,
        },
      };
    });

    //......................................SOGO header cards ........................

    builder.addCase(getSogoCards.pending, (state, action) => {
      return {
        ...state,
        sogoCards: {
          ...state.sogoCards,
          loading: true,
        },
      };
    });
    builder.addCase(getSogoCards.fulfilled, (state, action) => {
      return {
        ...state,
        sogoCards: {
          ...state.sogoCards,
          responseData: action.payload,
          loading: false,
        },
      };
    });
    //......................................OGA Milestone........................

    builder.addCase(getOGAMilestone.pending, (state, action) => {
      return {
        ...state,
        ogaMileStone: {
          ...state.ogaMileStone,
          loading: true,
        },
      };
    });
    builder.addCase(getOGAMilestone.fulfilled, (state, action) => {
      return {
        ...state,
        ogaMileStone: {
          ...state.ogaMileStone,
          responseData: action.payload,
          loading: false,
        },
      };
    });
    //..........................................................................

    //............................... Individual ......................//
    //cards
    builder.addCase(getIndividualCards.pending, (state, action) => {
      state.individualCards.loading = true;
    });
    builder.addCase(getIndividualCards.fulfilled, (state, action) => {
      state.individualCards.loading = false;
      state.individualCards.data = action.payload?.data;
    });
    //Monthly Perfomance
    builder.addCase(getIndividualMonthlyPerfomance.pending, (state, action) => {
      state.individualMonthlyPerfomance.loading = true;
    });
    builder.addCase(getIndividualMonthlyPerfomance.fulfilled, (state, action) => {
      state.individualMonthlyPerfomance.loading = false;
      state.individualMonthlyPerfomance.data = action.payload?.data;
    });

    //Course Sales Matrix
    builder.addCase(getCourseSalesMatrix.pending, (state, action) => {
      state.courseSaleMatrix.loading = true;
    });
    builder.addCase(getCourseSalesMatrix.fulfilled, (state, action) => {
      state.courseSaleMatrix.loading = false;
      state.courseSaleMatrix.data = action.payload?.data;
    });
    //............................... Project Section ......................//
    // Project Trend
    builder.addCase(getProjectTrend.pending, (state) => {
      state.projectTrend.loading = true;
    });
    builder.addCase(getProjectTrend.fulfilled, (state, action) => {
      state.projectTrend.loading = false;
      state.projectTrend.data = action.payload?.data;
    });

    // Course Trend
    builder.addCase(getCourseTrend.pending, (state) => {
      state.courseTrend.loading = true;
    });
    builder.addCase(getCourseTrend.fulfilled, (state, action) => {
      state.courseTrend.loading = false;
      state.courseTrend.data = action.payload?.data;
    });

    // Project Monthly Stats
    builder.addCase(getProjectMonthlyStats.pending, (state) => {
      state.projectMonthlyStats.loading = true;
    });
    builder.addCase(getProjectMonthlyStats.fulfilled, (state, action) => {
      state.projectMonthlyStats.loading = false;
      state.projectMonthlyStats.data = action.payload?.data;
    });

    // Wing Project Pivot
    builder.addCase(getWingProjectPivot.pending, (state) => {
      state.wingProjectPivot.loading = true;
    });
    builder.addCase(getWingProjectPivot.fulfilled, (state, action) => {
      state.wingProjectPivot.loading = false;
      state.wingProjectPivot.data = action.payload?.data;
    });

    // Project Performance Summary
    builder.addCase(getProjectPerformanceSummary.pending, (state) => {
      state.projectPerformanceSummary.loading = true;
    });
    builder.addCase(getProjectPerformanceSummary.fulfilled, (state, action) => {
      state.projectPerformanceSummary.loading = false;
      state.projectPerformanceSummary.data = action.payload?.data;
    });
  },
});

export const {
  clearTeamPerfomanceOverview,
  clearDailyTeamRevenue,
  clearDailyAssessmentCount,
  clearTeamWiseAnalysis,
  clearProjectWise,
  clearOgdOverview,
  clearTeamUserPerfomance,
  clearChaserCrewPerfomance,
  clearDetailedPerfomanceMetrics,
  clearOgdPointTracker,
} = pointTrackerSlice.actions;
export default pointTrackerSlice.reducer;
